module.exports = { 
    menu : { 

      srcQiYe: require("@/assets/images/English/img_jianjie.jpg"),
// 橡胶
rubber_img: require("@/assets/images/English/jiance_en.jpg"),
// 公司动态
CompanyDnamicImg: require("@/assets/images/English/img_dontai.jpg"),
// 行业质询
InformationImg: require("@/assets/images/English/img_zixun.jpg"),
// 实验室中心
LaboratoryCenterImg: require("@/assets/images/English/img_shiyanshi.jpg"),
// 人才招聘
RecruitmentImg: require("@/assets/images/English/img_zhaopin.jpg"),
// 预约检查
MakeAppointmentImg: require("@/assets/images/English/img_yuyue.jpg"),
//申请表
TestApplicationFormImg: require("@/assets/images/English/img_shenqingbiao.jpg"),
// 报告查询
TheReportQueryImg: require("@/assets/images/English/img_chaxun.jpg"),
// 送检流程
TheInspectionProcessImg: require("@/assets/images/English/img_liucheng.jpg"),
// 调查和报价
SurveyandQuotationImg: require("@/assets/images/English/img_diaocha.jpg"),
// 意见或建议
OpinionOrAdviceImg: require("@/assets/images/English/img_yijian.jpg"),
CustomerInspectionImg: require("@/assets/images/English/img_xuzhi.jpg"),

messageOne:"please enter user name",
messageTwo:"please enter phone",
messageSan:"please enter mailbox",
messageGongSi:"please enter company name",
messageYiJian:"please enter comment or suggestion",
jobworkmeassAge:"please enter Position",
tijiaoChengGong:"Send successfully",

messageHeFaEamil:"please enter Legitimate email",
messageHeFaPhone:"please enter Legal phone",

KEYWords:"Rubber Material Inspection，Plastic Material Inspection，Plastic And Rubber Testing，Material And Physical Property Testing，Sealtech.com(GuangZhou)Laboratory Ltd，GuangZhou Laboratory Ltd，Third-party Laboratory，Third-party Testing Laboratories。",
DEscription:"A third-party inspection laboratory with an independent legal entity, according to the Competence Assessment for Inspection Body and Laboratory Mandatory Approval – General Requirement for Inspection Body and Laboratory (RB/T214-2017) and the General Requirements for the Competence of Inspection and Calibration Laboratories/ HKOLAS (ISO/IEC 17025:2017) establish and maintain a laboratory management system, and is currently preparing for CMA and CNAS certification and accreditation work. Once approved, it will be able to provide customers with approved test reports."
+"Business scope: Provide testing and services for physical reliability performance items for rubber and plastic material products and daily necessities.",
BTitle:"Guangzhou Sealtech.com Aviation Seals Mfg. Ltd. Testing Center",
      languageName:"English",
        AboutUs:"About Us",
        business:  "Testing Scope",
        Rubber:"Rubber Material Inspection",
  
        PlasticMaterials: "Plastic Material Inspection",
        New:"News Information",
        CompanyDnamic: "Company Dynamics",
        IndustryInformation:"Industry Information",
        Team:"Team",
        OXinQuan:"O-ring Testing",
        DianziDianGong:"Electric and Electronic Products Testing",
        ZhiXun:"Call to Visit：",
        contactUs:"Contact Us",

        LaboratoryCenter:"Laboratory Center",//2
        Recruitment:"Talent Recruitment",
        customer:"Customer Service",
        theDay:"Appointment for Inspection",
        Testapplicationform:"Inspection Application Form",
        TheReportQuery:"Report Review",
        TheInspectionProcess:"The Inspection Process",
        contactUs:"Contact Us",
        SurveyAndQuotation: "Contact Us",
        suggestion:"Feedbacks & Suggestions",
        Instructions: "Inspection Notice",
        
        qiye:"Laboratory Overview",
        viewMore :"For More",
  
        RongYu:"Qualification",
        
        particulars:"Details",
  
  
        CustomerInstructions:"Inspection Notice",
        regulations:"Please check for the following Terms and Conditions before applying for the inspection",
        introduce:"Lab Introduction",
        ServicesAvailable:"Testing Items",
        USCDCLab:"Lab Photos",
        laboratoryEquipment:"Lab Equipment",
        portal:"Portal",
  
        // DetectionOfConsulting:"检测咨询",
        ApplicationForm:" Inspection Application Download",
        // TheInspectionProcess:"送检流程",
        CommentsOrSuggestions:"Feedback and Suggestion", 
  
  
        // footer
        SweepYardsAttention:"Scan a QR Code to Follow ",
        WeChatOfficialAccount:"Wechat Public Account",

        tel:"Tel:",
        fax:"Fax:",
        mailbox:" Email: ",
        companyAddress:" Address :",
        businessHours: "Business hours:",
        detectionRange:" Inspection range",
  
        CallUs: "Call Us",
  // 硬度试验
        briefIntroduction:"Basic Introduction",
        consult:"Consult ",
        feedback: "Feedback",
        testContent:" Project Name & Inspection Content",
        precautions: "Inspection Cycle and Precautions",
        ServiceContent:"Service Content",
        // testItem: "Inspection Items",
        advantages:"Our Advantages",
        recommendation:"Related Recommendations",
  
        releaseDate:"Date：",
        source:"From：",
        publisher:"Publisher：",
        previousposts:"Last：",
        nextChapter:"Next：",

        
liuyan:"Leave us a message",
dianziemit:"Email",
jobwork:"Position",
country:"Country/Province/City",
messageContents:"Content",
shurucocntent:"Please enter your message here and we will contact you as soon as possible.",
provide:"The persongal data you provide will be used for internal use only and you will be informed of future market information via email.",
  
  // 实验室
  // ServicesAvailable :"服务项目",
  LaboratoryPhotograph:"Lab Photos",
  laboratoryEquipment:"Lab Equipment",
  deliver:"Submit",
  
  WorkingArea:"Location：",
  recruitingNumbers:"Number of Recruits：",
  ExperienceRequirements:"Experience Requirement：",
  educationalRequirements:"Academic Requirement：",
  responsibilities:  "Job Description:",
  jobRequirements:"Person we are looking for:",
  placeholder:"please select",
  nodatatext:"no data",
  // 投递信息
  deliveryOfInformation:"Submit Information",
  name:"Name",
  phone :"Telephone",
  // mailboxer:"电子邮箱",
  entryDate:"Available Date",
  // entryDateer   : "选择日期",
  introduce:"Self-Introduction",
  offer:"  The persongal data you provide will be used for internal use only and you will be informed of future market information via email",
  SlectFile:"Select file",
  
  send:"Sent",
  reset:"Reset",
  Select:"Query",
  
  
  // 申请表
  EntrustedTesting :"Test Request Form",
  download:"Download",
  
  // 报告编号
  reportNumber:"Report Number",
  InquiryTip:"  Query prompt: You can scan the QR Code printed on the quotation for the updated report information.",
  ReportFiles :" (Result Enquiry Only) For more information, e.g. test report, please reach our sales representative.",
  salesman:" Sales Person:",
 
JianCeBiaoZhun:" Testing Standards：",
  searchResult:"Result Enquiry",
  inputError :"Error: no relevant data or information found.(Please contact our support team or the relevant person.)",
  applicationDate:"Date of Issue：",
  sampleName:"Sample Name：",
  testItem:"Test Item",
  testingResult:"Test Result：",
  TestCompletionDate:"Remarks：",
  confirm:"Confirm ",
  testItemer: "Model Specifications：",
  companyName:"Name of the Company",
  // details:"意见或建议",
  // interior:"您所提供得个人资料将只会作为公司内部使用，而未来相关得市场资讯将会通过电邮及时通知您",
  pleaseAdvise:"The persongal data you provide will be used for internal use only and you will be informed of future market information via email",
  
  jobtitle: "job title ",
  reDate:"Date",
  landlineMachine: "020-34773221 ext. 840",
    },
    content:{ 
      main:"this is content"
    } 
   }